import Layout from 'layout';
import { ExtendGridBox } from 'styles/integrations';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const Surveys = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Survicate');
  return (
    <Layout
      metaTitle="Surveys | Integrations"
      canonical="/integrations/surveys/"
      metaDescription="Learn even more about your users – just ask them! Connect LiveSession with your online survey software."
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/surveys/">
                <strong>Surveys</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="Surveys" underlineColor="#F8D047" />
          <Content activeCategory="Surveys" hideTitle>
            <Banner
              activeCategory="Surveys"
              card={mostPopularCard}
              text="Learn even more about your users – just ask them! Connect LiveSession with your online survey software."
              underlineColor="#F8D047"
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default Surveys;
